import { takeEvery, put, call, select } from "redux-saga/effects";
import { TResult } from "../../../../sg-core";
import {
    IRequestFetchPersons,
    createSuccessFetchPersons,
    createFailureFetchPersons,
    requestPersons
} from "../actions/personAction";
import IPerson from "../../interfaces/IPerson";
import { getPersonService } from "../../services/personService";
import { HPR } from "../../../endpoints";
import { selectApiService } from "../../auth/store/authSelectors";

const makeFetchPersonsSaga = () =>
    function* saga(action: IRequestFetchPersons) {
        const { personIds } = action.payload
        try {
            const { apiService, anonymousSession } = yield select(selectApiService);
            const personService = getPersonService(apiService, HPR, anonymousSession)


            const result: TResult<IPerson[]> = yield call(personService.getPersons, personIds);

            if (result.isSuccess) {
                yield put(createSuccessFetchPersons(result.value));
            } else {
                yield put(createFailureFetchPersons(result.isFailure ? result.error : new Error(), personIds));
            }
        } catch (e) {
            yield put(createFailureFetchPersons(e as Error, personIds));
        }
    };

export default function create() {
    return takeEvery(
        requestPersons,
        makeFetchPersonsSaga(),
    );
}